<template>
    <div ref="map" class="map" @dragover="dragOver">
        <div ref="overlay" class="overlay" draggable @dragstart="overlayDragStart" @drag="dragOverlay">
            <div ref="leftCursor" class="cursor left" draggable @dragstart="cancelDragImage" @drag="dragLeftCursor" @dragend="cursorDrop"></div>
            <div ref="rightCursor" class="cursor right" draggable @dragstart="cancelDragImage" @drag="dragRightCursor" @dragend="cursorDrop"></div>
        </div>
    </div>
</template>

<script>
    import WaveSurfer from 'wavesurfer.js/dist/wavesurfer.min';
    export default {
        name: 'WaveformMap',
        props: {
            blob: Blob
        },
        watch: {
            'blob': 'createWaveForm'
        },
        data() {
            return {
                map: null,
                dragData: {
                    startPos: 0,
                    clientX: 0,
                    clientY: 0,
                    overlayStartPos: {
                        startX: 0, startY: 0
                    }
                }
            }
        },
        mounted() {
        },
        methods: {
            reset() {
                if (this.map) this.map.destroy()
                this.$refs.overlay.style.left = '0px'
                this.$refs.overlay.style.right = '0px'
            },
            createWaveForm() {
                if (!this.blob) return

                this.map = WaveSurfer.create({
                    container: this.$refs.map,
                    waveColor: '#999',
                    progressColor: '#666',
                    barWidth: 3,
                    barGap: 0.5,
                    height: 30,
                    barHeight: 1,
                    autoCenter: true,
                    forceDecode: true,
                    interact: false,
                    cursorWidth: 0,
                    responsive: true
                })
                this.map.on('ready', () => {

                    var wave = this.$refs.map.querySelector("wave");
                    if (wave)
                        wave.style.overflow = "hidden";
                    this.$emit('ready');
                })
                this.map.loadBlob(this.blob)
            },

            // To remove the drag helper
            cancelDragImage(e) {
                e.dataTransfer.setData("text", " "); // Fix for firefox s***
                console.log(e.dataTransfer);

                let pixel = document.getElementById('dummypixel')
                if (!pixel) {
                    pixel = document.createElement('canvas')
                    pixel.id = 'dummypixel'
                    pixel.width = 1
                    pixel.height = 1
                    pixel.style.position = 'absolute'
                    document.body.appendChild(pixel)
                }
                e.dataTransfer.setDragImage(pixel, 0, 0)
            },

            scrollBy(scrollRatio) {
                //console.log("WaveMap scrollBy");
                const mapRect = this.$refs.map.getBoundingClientRect()
                const overlayRect = this.$refs.overlay.getBoundingClientRect()
                this.$refs.overlay.style.left = mapRect.width * scrollRatio + 'px'
                this.$refs.overlay.style.right = mapRect.width - (mapRect.width * scrollRatio + overlayRect.width) + 'px'
            },

            dragOver(e) {
                // Used to track mouse position when dragging cursor
                //console.log("Dragover : ", e);
                this.dragData = Object.assign(this.dragData, {
                    clientX: e.clientX, clientY: e.clientY
                })
            },
            dragLeftCursor(e) {
                e.stopPropagation()
                const x = (this.dragData || {}).clientX
                const mapRect = this.$refs.map.getBoundingClientRect()
                const offsetX = Math.max(0, x - mapRect.left)
                // console.log("MapRect :", mapRect); // OK : Position of the map on the screen
                // move the cursor by changing the overlay position
                this.$refs.overlay.style.left = offsetX + 'px'
            },
            dragRightCursor(e) {
                e.stopPropagation()
                const x = (this.dragData || {}).clientX
                if (!x) return // clientX is 0 when the mouse leaves the screen
                const mapRect = this.$refs.map.getBoundingClientRect()
                const offsetX = Math.max(0, mapRect.right - x)
                this.$refs.overlay.style.right = offsetX + 'px'
            },
            cursorDrop(e) {
                let pixel = document.getElementById('dummypixel');
                if (pixel) pixel.remove();
                e.stopPropagation()
                const mapRect = this.$refs.map.getBoundingClientRect()
                const overlayRect = this.$refs.overlay.getBoundingClientRect()
                const scrollLeft = overlayRect.left - mapRect.left
                const scrollLeftRatio = scrollLeft / mapRect.width
                this.$emit('zoom', this.getZoom())
                this.$emit('move', scrollLeftRatio)
            },
            overlayDragStart(e) {
                this.dragData.startPos = e.clientX
                this.dragData.overlayStartPos = {
                    startLeft: parseFloat(this.$refs.overlay.style.left) || 0,
                    startRight: parseFloat(this.$refs.overlay.style.right) || 0
                }
                this.cancelDragImage(e)
            },
            getZoom() {
                const mapRect = this.$refs.map.getBoundingClientRect()
                const overlayRect = this.$refs.overlay.getBoundingClientRect()
                const ratio = overlayRect.width / mapRect.width
                const duration = this.map.getDuration()
                const pxPerSecond = (mapRect.width / duration) / ratio
                return pxPerSecond
            },
            dragOverlay(e) {
                const mapRect = this.$refs.map.getBoundingClientRect()
                const overlayRect = this.$refs.overlay.getBoundingClientRect()
                const minDelta = - this.dragData.overlayStartPos.startLeft
                const maxDelta = this.dragData.overlayStartPos.startRight
                let delta = ((this.dragData || {}).clientX || 0) - this.dragData.startPos
                delta = Math.max(minDelta, delta)
                delta = Math.min(maxDelta, delta)
                this.$refs.overlay.style.left = (this.dragData.overlayStartPos.startLeft + delta) + 'px'
                this.$refs.overlay.style.right = (this.dragData.overlayStartPos.startRight - delta) + 'px'
                const scrollLeft = overlayRect.left - mapRect.left
                const scrollLeftRatio = scrollLeft / mapRect.width
                this.$emit('move', scrollLeftRatio)
            },
        }
    };
</script>